// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"445":"8fab8f80","527":"c0c32740","689":"c0c32740","863":"c0c32740","896":"c0c32740"}[chunkId] + ".chunk.css";
};